import { api } from "../lib/api";

export const digestService = {
  preview: () => api.get("/digest/preview").then((r) => r.data),
  sendNow: () => api.post("/digest/send-now").then((r) => r.data),
  last: () => api.get("/digest/last").then((r) => r.data),
};
